export const formatJobCount = (value) =>
    value === null || value === undefined ? 'Ожидание' : value.toFixed(3);

export const formatJobNormOfTime = (value) =>
    value === null || value === undefined ? 'Ожидание' : value.toFixed(3);

export const formatJobCompletion = (completion) =>
    completion ? new Date(completion).toLocaleDateString() : '—';
